export enum LoggingLevel {
    Debug = 0,
    Info,
    Warn,
    Error
}